<template>
  <v-container fluid class="d-flex align-center justify-center fill-height pa-0 h-screen"
    style="background-color: #f6f4f1;">
    <v-card elevation="18" width="450" class="pa-8 rounded-xl" style="background-color: #ffffff;">
      <div class="text-center mb-8">
        <h2 class="text-h5 font-weight-bold mb-1 text-primary">
          Recuperar Senha
        </h2>
        <p class="text-body-2 text-neutrals_muted">
          Informe seu e-mail para enviarmos um código de verificação.
        </p>
      </div>

      <v-form @submit.prevent="handleForgotPassword" ref="formRef">
        <v-text-field v-model="email" label="E-mail" type="email" prepend-inner-icon="mdi-email-outline"
          variant="outlined" required class="mb-6" color="primary" :error-messages="validationErrors.email" />

        <v-btn type="submit" block size="large" class="text-white" :loading="isSubmitting" :disabled="isSubmitting"
          color="primary" style="font-weight:600;">
          Enviar Código
        </v-btn>
      </v-form>

      <div class="d-flex justify-center mt-4">
        <a @click.prevent="goToLogin" href="#" class="text-body-2 text-decoration-none text-primary">
          Lembrou da senha? Voltar ao Login
        </a>
      </div>
      
    </v-card>
  </v-container>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
// Ajuste os imports abaixo para onde seus arquivos estão localizados
import api from "@/services/api"; 
import { useToastStore } from '@/store/toast'; 

const email = ref("");
const isSubmitting = ref(false);
const validationErrors = ref({});

const router = useRouter();
const toastStore = useToastStore();

function validateForm() {
  const errors = {};
  if (!email.value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
    errors.email = "E-mail inválido ou obrigatório.";
  }
  validationErrors.value = errors;
  return Object.keys(errors).length === 0;
}

async function handleForgotPassword() {
  if (!validateForm()) {
    toastStore.showToast({
      message: 'Por favor, informe um e-mail válido.',
      color: 'warning',
    });
    return;
  }

  isSubmitting.value = true;
  try {
    // Rota para solicitar o OTP (o backend deve enviar o código para o email)
    const response = await api.post("/forgot-password-request", { 
      email: email.value,
    });
    
    // Supondo que a resposta de sucesso inclua o código OTP ou uma mensagem de sucesso
    toastStore.showToast({
      message: response.message || 'Código de verificação enviado para o seu e-mail!',
      color: 'success',
    });

    // Redireciona para a tela de validação OTP, passando o email na query
    router.push({ name: 'otp-validation', query: { email: email.value } });

  } catch (error) {
    console.error("Erro ao solicitar recuperação:", error);
    toastStore.showToast({
      message: error?.response?.data?.error || 'Erro ao processar a solicitação.',
      color: 'error',
    });
  } finally {
    isSubmitting.value = false;
  }
}

const goToLogin = () => {
  router.push({ name: 'login' });
}
</script>

<style scoped>
/* Estilos para garantir cores da paleta */
.text-primary {
  color: #152a34 !important;
}
.text-neutrals_muted {
  color: #6b7280 !important;
}
</style>